<template>
    <v-dialog v-model="dialogSwitch" persistent scrollable width="700">
        <v-form class="mb-3" validate-on="input lazy" @submit.prevent="save">
            <v-card>
                <v-card-title id="heading" class="d-flex justify-space-between">
                    <h4>Map</h4>
                    <v-btn density="compact" icon="mdi-close" variant="flat" @click="$emit('update:modelValue',false)"/>
                </v-card-title>

                <v-container>
                    <div>
                        <v-row>
                            <v-col cols="12" style="height: 350px">
                                <l-map ref="mapContainer" :center="mapCenter" :zoom="15" @ready="mapIsReady">
                                    <l-tile-layer :url="mapConfig.streetUrl"/>
                                </l-map>
                            </v-col>
                        </v-row>
                    </div>
                </v-container>

                <v-card-actions class="px-4 d-flex justify-end">
                    <v-btn size="small" type="button"
                           @click="$emit('update:modelValue',false)">
                        Close
                    </v-btn>
                    <v-btn color="primary" size="small" type="submit">Save</v-btn>
                </v-card-actions>
            </v-card>
        </v-form>
    </v-dialog>
</template>

<script setup>
import {GeoSearchControl, OpenStreetMapProvider} from "leaflet-geosearch";
import {mapConfig} from "@/composables/mapConfig";

import "leaflet-draw";
import L from "leaflet";
import {reactive, ref} from "vue";
import {defineProps, defineEmits} from "vue";
import {LMap, LTileLayer} from "@vue-leaflet/vue-leaflet";

const props = defineProps({
    modelValue: Boolean,
    setMapValues: Object,
});

const mapContainer = ref();
const mapCenter = ref([props.setMapValues.center_lat || 47.41322, props.setMapValues.center_lon || -1.219482]);
const dialogSwitch = ref(props.modelValue);
const geofenceFormData = reactive({
    valid: false,
    type: 0,
    radius: props.setMapValues.radius,
    center_lat: props.setMapValues.center_lat,
    center_lon: props.setMapValues.center_lon,
    polygon_coordinates: null,
});

const emits = defineEmits(['update:modelValue', 'mapValue']);

const mapIsReady = () => {
    const map = mapContainer.value.leafletObject;
    map.attributionControl.remove();
    /*Add Draw Geo Search Control*/
    const geoSearchOptions = new GeoSearchControl({
        style: "bar",
        autoClose: true,
        keepResult: true,
        showMarker: false,
        searchLabel: "Enter address",
        provider: new OpenStreetMapProvider({searchUrl: mapConfig.searchUrl, reverseUrl: mapConfig.reverseUrl}),
    });
    map.addControl(geoSearchOptions);


    /*Add Draw Tool Bar Control*/
    const drawnItems = new L.FeatureGroup();
    map.addLayer(drawnItems);
    const drawControl = new L.Control.Draw({
        draw: {
            circle: true,
            polygon: false,
            // disable toolbar item by setting it to false
            marker: false,
            polyline: false,
            rectangle: false,
            circlemarker: false,
        },
        edit: {
            remove: !!props.setMapValues.radius,
            featureGroup: drawnItems
        }
    });
    map.addControl(drawControl);

    if (!!props.setMapValues.radius) {
        if (props.setMapValues.type === 0) {
            drawnItems.addLayer(L.circle([props.setMapValues.center_lat, props.setMapValues.center_lon], {
                // editable: true,
                radius: props.setMapValues.radius * 1000,
            }));
            mapCenter.value = [props.setMapValues.center_lat, props.setMapValues.center_lon];
        }
    }

    map.on('draw:created', function (e) {
        drawnItems.eachLayer(function (layer) {
            drawnItems.removeLayer(layer);
        });

        let type = e.layerType,
            layer = e.layer;

        if (type === 'circle') {
            geofenceFormData['type'] = 0;
            geofenceFormData['radius'] = (layer.getRadius() / 1000);
            geofenceFormData['center_lat'] = layer.getLatLng().lat;
            geofenceFormData['center_lon'] = layer.getLatLng().lng;
        } else if (type === 'polygon') {
            geofenceFormData['type'] = 1;
            geofenceFormData['polygon_coordinates'] = layer.getLatLngs()[0];
        }
        drawnItems.addLayer(layer);
    });

    map.on('draw:edited', function (e) {
        e.layers.eachLayer(function (layer) {
            if (layer instanceof L.Circle) {
                geofenceFormData['type'] = 0;
                geofenceFormData['radius'] = (layer.getRadius() / 1000);
                geofenceFormData['center_lat'] = layer.getLatLng().lat;
                geofenceFormData['center_lon'] = layer.getLatLng().lng;
            } else if (layer instanceof L.Polygon) {
                geofenceFormData['type'] = 1;
                geofenceFormData['polygon_coordinates'] = layer.getLatLngs()[0];
            }
        });
    });

    map.on('draw:deleted', function (e) {
        drawnItems.eachLayer(function (layer) {
            drawnItems.removeLayer(layer);
        });
        geofenceFormData['type'] = 0;
        geofenceFormData['radius'] = null;
        geofenceFormData['center_lat'] = null;
        geofenceFormData['center_lon'] = null;
        geofenceFormData['polygon_coordinates'] = null;
    });
}

const save = () => {
    emits('mapValue', geofenceFormData);
    emits('update:modelValue', false);
}


</script>